<template>
    <div class="scrim"> <!-- full background coloring -->
        <slot></slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Modal',    
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
    }
}
</script>

<style scoped lang="scss">
.scrim {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba($black, .8);

    z-index: 8;
    display: flex;
    justify-content: center;
    align-items: center;

    .no-bg {
        color: $white;
        width: 70%;
        text-align: center;
        max-width: 620px;

        button {
            border: solid 2px $white;
            color: $white;
            background: none;
            border-radius: 0;
            padding: $s1 $s2;
            margin-top: $s2;
        }
    }

    .card-bg {
        position: relative;
        background: $white;
        padding: 0 $s3 $s3;
        max-width: 800px;
        width: 70%;
        max-height: 80vh;
        overflow-y: auto;

        h2 {
            margin: $s3 0;
            max-width: 600px;
        }

        .question {
            margin: 0 0 $s2;
            &:not(:last-child) {
                border-bottom: solid 1px $light-gray1;
            }
    
            .h4 {
                margin-bottom: 0;
            }
            p {
                margin-top: .5rem;
                font-size: 1rem;
            }
        }

        button {
            border: none;
            background: none;
            border-radius: 0;
            display: block;
            position: sticky;
            margin-left: auto;
            transform: translateX($s2);
            top: $s2;
        }
    }
}
</style>